import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { AuthManager, NotFoundPage, PrivateRoute, PublicRoute } from "components";
import { PrivateRouteLayout, PublicRouteLayout, RouteWithErrorBoundary } from "layouts";
import { ApiKeys, Auth, RecallsDashboard, RecallsUpload, Users } from "modules";
import { PATHS } from "router/paths";

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths, import/order
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const privateRoutes = [PATHS.UPLOAD, PATHS.GENERATE_RECALL_TOKENS, PATHS.USERS, PATHS.DASHBOARD];

  return (
    <>
      <ToastContainer position="top-right" autoClose={1500} closeOnClick draggable theme="light" />
      <Router>
        <AuthManager />
        <Switch>
          <RouteWithErrorBoundary exact path={[PATHS.HOME, PATHS.LOGIN]}>
            <PublicRouteLayout>
              <Switch>
                <PublicRoute exact path={[PATHS.HOME, PATHS.LOGIN]} component={Auth} />
              </Switch>
            </PublicRouteLayout>
          </RouteWithErrorBoundary>

          <RouteWithErrorBoundary exact path={privateRoutes}>
            <PrivateRouteLayout>
              <Switch>
                <PrivateRoute exact path={PATHS.UPLOAD} component={RecallsUpload} />
                <PrivateRoute exact path={PATHS.USERS} component={Users} />
                <PrivateRoute exact path={PATHS.DASHBOARD} component={RecallsDashboard} />
                <PrivateRoute exact path={PATHS.GENERATE_RECALL_TOKENS} component={ApiKeys} />
              </Switch>
            </PrivateRouteLayout>
          </RouteWithErrorBoundary>

          <Route path="*" component={NotFoundPage} />
        </Switch>
      </Router>
      <ReactQueryDevtools initialIsOpen={false} />
    </>
  );
};

export default App;
